<template>
  <NUIButton :obj="this.calculations" :displayType="'icon'" />
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import NUIButton from './nelsonUI/NUIButton.vue';
import { usePipeStore } from '@/store/PipeStore';

export default {
  data () {
    return {
      calculations: {
        label: 'Pipes',
        icon: 'table',
        value: 'pipes',
        orientation: 'top',
        marker: 'var(--nelson-green)',
        func: this.handlePipes,
      }
    };
  },
  methods: {
    handlePipes () {
      const pipeStore = usePipeStore();
      let pipe = pipeStore.getPipes[0];
      pipeStore.getPipes.forEach((element) => {
        element.isHover = false;
      });
      pipeStore.setPipeModalVisible(true);
      pipeStore.setEditedPipe(pipe);
      useModalStore().showModal('pipe');
    }
  },
  components: {
    NUIButton
  }
};
</script>

<style scoped>
.calculations-button {
  width: 100px;
  background-color: yellowgreen;
  cursor: pointer;
}
</style>